// extracted by mini-css-extract-plugin
export default {"wording":"tips_wording__fggwn"};